module.exports = "<div id='donut-element'></div>";


//////////////////
// WEBPACK FOOTER
// ./src/app/components/donutChart/template.html
// module id = 1595
// module chunks = 0